import { booleanParser } from './booleanParser';

export function getBaseURL() {
	// version 2 api
	if (booleanParser(process.env.REACT_APP_TEST_SERVER)) {
		return {
			base: 'https://testapi.kipaa.ir/keepaapp/v1/KeepaApp/',
			customize: 'https://testapi.kipaa.ir/keepaapp/v1/',
			wallet: 'https://testapi.kipaa.ir/wallet/v1/Wallet',
		};
	} else {
		return {
			base: 'https://api.kipaa.ir/keepaapp/v1/KeepaApp/',
			customize: 'https://api.kipaa.ir/keepaapp/v1/',
			wallet: 'https://api.kipaa.ir/wallet/v1/Wallet',
		};
	}
}

export function getBaseNewURL() {
	// version 2.5 api
	if (booleanParser(process.env.REACT_APP_TEST_SERVER)) {
		return {
			base: 'https://testapi.kipaa.ir/Interface/v1/KeepaApp',
			customize: 'https://testapi.kipaa.ir/Interface/v1/',
			wallet: 'https://testapi.kipaa.ir/Interface/v1/KeepaApp/',
		};
	} else {
		return {
			base: 'https://api.kipaa.ir/Interface/v1/KeepaApp',
			customize: 'https://api.kipaa.ir/Interface/v1/',
			wallet: 'https://api.kipaa.ir/Interface/v1/KeepaApp/',
		};
	}
}

export const mehrBaseUrl = 'https://hamrahbank.qmb.ir';
